import { useState, useEffect, useCallback } from 'react'
import { Helmet } from 'react-helmet'

import { MainLayout } from '@itau-loans-www/templates'
import { isClient } from '@itau-loans-www/utils'
import classnames from 'classnames'

import './application.scss'

export default ({
  children,
  className,
  footer,
  hasCookieBar,
  currentPage,
  ...props
}) => {
  const [partner, setPartner] = useState('')

  const classNamesLayout = classnames('application-layout', {
    'application-layout--partner': isClient() && partner,
    'application-layout--magalu': isClient() && partner === 'magalu',
    'application-layout--assai': isClient() && partner === 'assai',
    'application-layout--telhaNorte': isClient() && partner === 'telhaNorte',
    'application-layout--pirelli': isClient() && partner === 'pirelli',
    'application-layout--carrefour': isClient() && partner === 'carrefour',
    'application-layout--crediffato': isClient() && partner === 'crediffato',
    'application-layout--atacadao': isClient() && partner === 'atacadao',
    [className]: className
  })

  const classNamesContent = classnames('application-content', {
    [className]: className
  })

  const loadPartner = useCallback(() => {
    if (isClient()) {
      setPartner(localStorage.getItem('partner'))
    }
  }, [])

  useEffect(() => {
    loadPartner()
  }, [loadPartner])

  return (
    <div className="layout-wrapper">
      <div className="application-layout__content">
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>

        <div {...props} className={classNamesLayout}>
          <MainLayout
            hasFooter={footer}
            hasCookieBar={hasCookieBar}
            currentPage={currentPage}
            partnerName={partner}
          >
            <main className={classNamesContent}>{children}</main>
          </MainLayout>
        </div>
      </div>
    </div>
  )
}
